export default __webpack_public_path__ + "static/media/Flexi&comprehensive_motor.fab367a9.png";